module.exports = __webpack_public_path__ + "img/SET_BUTTON_1.61eabcc6.svg";